<template>
  <BaseCard>
    <BaseCardBody>
      <BaseVeeForm
        :action="submit"
        ensure-error-keys-camel-case
        v-slot="formProps"
        class="space-y-8"
      >
        <div class="space-y-1">
          <h4 class="text-indigo-500">Ενεργοποίηση χρήστη</h4>
          <p class="text-gray-600">
            Παρακαλώ καταχωρήστε ένα κωδικό με τουλάχιστον 8 χαρακτήρες που θα χρησιμοποιείτε για
            την πρόσβασή σας
          </p>
        </div>
        <!-- Header -->

        <div class="space-y-8">
          <BaseFormGroup v-if="email" class="w-full">
            <BaseFormLabel> Email </BaseFormLabel>
            <BaseFormInput type="text" :value="email" class="bg-gray-50" readonly />
          </BaseFormGroup>

          <PasswordGenerator @password-generated="setRandomPassword" />
          <ValidationProvider
            name="password"
            vid="password"
            rules="required|min:8|confirmed:passwordConfirmation"
            slim
          >
            <template #default="fieldProps">
              <BaseFormGroup class="w-full">
                <div class="flex gap-x-2">
                  <BaseFormLabel> Κωδικός * </BaseFormLabel>
                  <button
                    type="button"
                    class="text-sm text-blue-600 underline"
                    @click="showPassword = !showPassword"
                  >
                    {{ showPassword ? 'Απόκρυψη' : 'Εμφάνιση' }}
                  </button>
                </div>
                <BaseFormInput
                  id="password"
                  :type="showPassword ? 'text' : 'password'"
                  v-model="formData.password"
                  :disabled="formProps.isPending"
                  :invalid="fieldProps.failed"
                  class="bg-white"
                  placeholder="enter password..."
                />
                <BaseFormInlineMessage v-if="fieldProps.failed" danger>
                  {{ fieldProps.errors[0] }}
                </BaseFormInlineMessage>
              </BaseFormGroup>
            </template>
          </ValidationProvider>

          <ValidationProvider name="confirmation" vid="passwordConfirmation" rules="required" slim>
            <template #default="fieldProps">
              <BaseFormGroup class="w-full">
                <BaseFormLabel> Επαλήθευση κωδικού * </BaseFormLabel>
                <BaseFormInput
                  :type="showPassword ? 'text' : 'password'"
                  v-model="formData.passwordConfirmation"
                  :disabled="formProps.isPending"
                  class="bg-white"
                  :invalid="fieldProps.failed"
                />
                <BaseFormInlineMessage v-if="fieldProps.failed" danger>
                  {{ fieldProps.errors[0] }}
                </BaseFormInlineMessage>
              </BaseFormGroup>
            </template>
          </ValidationProvider>
        </div>

        <div class="space-x-2 text-right">
          <BaseButton primary :disabled="formProps.isPending || formProps.invalid">
            Υποβολή
          </BaseButton>
        </div>
      </BaseVeeForm>
    </BaseCardBody>
  </BaseCard>
</template>

<script>
import mapKeysToSnakeCase from '@/utils/map-keys-to-snake-case';
import { ApiClient } from '@/api/client';
import PasswordGenerator from '../PasswordGenerator.vue';

const client = new ApiClient('/');

export default {
  name: 'UserActivationForm',
  props: {
    activationUrl: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      email: '',
      formData: {
        password: '',
        passwordConfirmation: '',
      },
      pathname: '',
      query: {
        expires: '',
        signature: '',
      },
      showPassword: false,
    };
  },
  created() {
    try {
      const url = new URL(decodeURIComponent(this.$route.query?.activation_url || ''));
      const params = url.searchParams;
      const [email, ...restURLParts] = url.pathname.split('/').reverse();
      this.email = email || '';
      this.pathname = [encodeURIComponent(email), ...restURLParts].reverse().join('/');
      this.query.expires = params.get('expires');
      this.query.signature = params.get('signature');
    } catch (error) {
      //
    }
  },
  methods: {
    setRandomPassword(password) {
      this.formData.password = password;
      this.formData.passwordConfirmation = password;
    },
    async submit() {
      try {
        await client.post(this.pathname, mapKeysToSnakeCase(this.formData), { params: this.query });
        await this.$store.dispatch('ui/auth/user');
        this.$emit('user-activated');
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
  components: { PasswordGenerator },
};
</script>
